import { createAsyncThunk } from 'legacy/lut/store/utils/createAsyncThunk'

import { applyChanges, IApplyChanges } from '../../../components/QBR/api/applyChanges'
import { IFetchQbrDocumentResponse } from '../../../models/qbr/IFetchQbrDocumentResponse'
import { REQUEST_APPLY_CHANGES } from '../constants'

export const requestApplyChanges = createAsyncThunk<IFetchQbrDocumentResponse, IApplyChanges>(
  REQUEST_APPLY_CHANGES,
  async (params, { rejectWithValue }) => {
    const response = await applyChanges(params)
    const { Data } = response

    if (!Data || Data.length === 0) {
      return rejectWithValue('No data returned')
    }

    return Data[0]
  }
)
